import { render, staticRenderFns } from "./DatasetSourceTransform.vue?vue&type=template&id=cd5f150e&scoped=true&"
import script from "./DatasetSourceTransform.vue?vue&type=script&lang=js&"
export * from "./DatasetSourceTransform.vue?vue&type=script&lang=js&"
import style0 from "./DatasetSourceTransform.vue?vue&type=style&index=0&id=cd5f150e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd5f150e",
  null
  
)

export default component.exports